

export const defaultMainConfig = {
    "language": [
        "English",
        "Chinese",
        "Japanese",
        "Italian",
        "Korean",
        "Other"
    ],
    "units": [
        {
            "name": "mm",
            "ratio": 1000
        },
        {
            "name": "um",
            "ratio": 1
        },
        {
            "name": "mil",
            "ratio": 25.4
        },
        {
            "name": "oz",
            "ratio": 35.87
        }
    ],
    "labels": [
        {
            "label": "客户订单",
            "description": "客户向PCB制造商下发的正式采购订单，一般包含订单编号，产品型号，数量，交货日期，价格条款等"
        },
        {
            "label": "ENG文件",
            "description": "PCB工程制造文件，包含工艺参数、特殊加工要求（如阻抗控制、沉金厚度）、层压结构及关键生产指示。"
        },
        {
            "label": "ECN文件",
            "description": "工程变更通知文件，记录设计或工艺的变更内容（如材料替换、线路调整、孔位修改），确保生产与最新要求一致。"
        },
        {
            "label": "SOW文件",
            "description": "项目工作说明书，明确PCB项目的范围、交付物、验收标准、里程碑节点及双方责任划分。"
        },
        {
            "label": "层压结构",
            "description": "PCB叠层设计规范，定义各层材料（如FR-4、高频材料）、厚度、铜箔重量（如1oz）、介电常数及层间对准要求。"
        },
        {
            "label": "阻抗数据",
            "description": "PCB关键信号线的阻抗控制要求，包括目标阻抗值（如50Ω）、线宽/线距、参考层及容许偏差范围。"
        },
        {
            "label": "SPEC文件",
            "description": "PCB技术规格文档，涵盖产品性能标准、材料规格、工艺要求（如IPC标准）、测试方法及验收准则。"
        }
    ],
    "params": [
        {
            "keyword": "拼板单位",
            "category": "基础信息",
            "description": "生产时多个单板（PCS）组成的集合单元（SET）",
            "type": "str",
            "expect": {
                "keyword": "拼板单位",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "成品板厚",
            "category": "基础信息",
            "description": "PCB电路板生产最终成品的板厚",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "expect": {
                "keyword": "成品板厚",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "成品板厚公差",
            "category": "基础信息",
            "description": "PCB电路板生产最终成品的板厚允许的厚度偏差范围",
            "type": "range",
            "unit": [],
            "expect": {
                "keyword": "成品板厚公差",
                "min": "",
                "max": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "产品阶数",
            "category": "基础信息",
            "description": "",
            "type": "str",
            "expect": {
                "keyword": "产品阶数",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "pcs长",
            "category": "基础信息",
            "description": "PCB制造时单板pcs的长度尺寸",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "expect": {
                "keyword": "pcs长",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "pcs宽",
            "category": "基础信息",
            "description": "PCB制造时单板pcs的宽度尺寸",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "expect": {
                "keyword": "pcs宽",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "set长",
            "category": "基础信息",
            "description": "PCB制造时拼板set的长度尺寸",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "expect": {
                "keyword": "set长",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "set宽",
            "category": "基础信息",
            "description": "PCB制造时拼板set的长度尺寸",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "expect": {
                "keyword": "set宽",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "pcs在ser中数量",
            "category": "基础信息",
            "description": "单个拼板set包含的单板pcs数量",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "pcs在ser中数量",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "成型公差",
            "category": "基础信息",
            "description": "外形加工（锣板/冲板）的尺寸偏差",
            "type": "range",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "expect": {
                "keyword": "成型公差",
                "min": "",
                "max": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "板子结构",
            "category": "基础信息",
            "description": "",
            "type": "str",
            "expect": {
                "keyword": "",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "检验标准",
            "category": "基础信息",
            "description": "国际电子工业联接协会制定的PCB制造与验收标准",
            "type": "enumeration",
            "enumeration": [
                "class1",
                "class2",
                "class3"
            ],
            "expect": {
                "keyword": "检验标准",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "高压测试",
            "category": "基础信息",
            "description": "施加高电压检测绝缘性能",
            "type": "int",
            "unit": [
                "VDC",
                "VAC"
            ],
            "expect": {
                "keyword": "高压测试",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "APQP",
            "category": "基础信息",
            "description": "汽车行业先期产品质量策划流程,确保产品从设计到量产的可靠性",
            "type": "str",
            "expect": {
                "keyword": "APQP",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "PPAP",
            "category": "基础信息",
            "description": "生产件批准程序（汽车行业必备）",
            "type": "str",
            "expect": {
                "keyword": "PPAP",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "IMDS",
            "category": "基础信息",
            "description": "国际材料数据系统（用于环保合规）",
            "type": "str",
            "expect": {
                "keyword": "IMDS",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "CAMDS",
            "category": "基础信息",
            "description": "中国汽车材料数据系统（类似IMDS）",
            "type": "str",
            "expect": {
                "keyword": "CAMDS",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "TG",
            "category": "基础信息",
            "description": "基材玻璃化转变温度",
            "type": "int",
            "unit": [
                "℃"
            ],
            "expect": {
                "keyword": "",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "CTI",
            "category": "基础信息",
            "description": "耐漏电起痕指数,用于评估绝缘材料在潮湿和污染条件下的耐电痕化能力",
            "type": "int",
            "unit": [
                "V"
            ],
            "expect": {
                "keyword": "",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "板材类型",
            "category": "基础信息",
            "description": "PCB板基材种类",
            "type": "str",
            "expect": {
                "keyword": "板材类型",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "板材颜色",
            "category": "基础信息",
            "description": "基材本体的颜色",
            "type": "str",
            "expect": {
                "keyword": "板材颜色",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "板材水印",
            "category": "基础信息",
            "description": "基材上的制造商标识或者认证标记",
            "type": "str",
            "expect": {
                "keyword": "板材水印",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "板材型号",
            "category": "基础信息",
            "description": "具体的材料型号",
            "type": "str",
            "expect": {
                "keyword": "板材型号",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "板弯板翘",
            "category": "基础信息",
            "description": "PCB电路板平面度偏差",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "板弯板翘",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "无卤素",
            "category": "基础信息",
            "description": "材料中卤素含量≤900ppm（环保要求）",
            "type": "str",
            "expect": {
                "keyword": "无卤素",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "叉板",
            "category": "基础信息",
            "description": "拼板中用于分割的辅助小板。",
            "type": "str",
            "expect": {
                "keyword": "叉板",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "叉板数量",
            "category": "基础信息",
            "description": "单个拼板中叉板的数量。",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "叉板数量",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "叉位种数",
            "category": "基础信息",
            "description": "叉板的设计种类数（如不同形状）。",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "叉位种数",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "叉板比例",
            "category": "基础信息",
            "description": "叉板面积占拼板总面积的比例。",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "离子污染",
            "category": "基础信息",
            "description": "表面残留离子浓度",
            "type": "str",
            "expect": {
                "keyword": "",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "成型方式-锣板",
            "category": "机加工",
            "description": "使用CNC锣机切割外形",
            "type": "str",
            "expect": {
                "keyword": "成型方式-锣板",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "成型方式-冲板",
            "category": "机加工",
            "description": "使用模具冲压成型",
            "type": "str",
            "expect": {
                "keyword": "成型方式-冲板",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "成型方式-V-cut",
            "category": "机加工",
            "description": "V型槽分割拼板。",
            "type": "str",
            "expect": {
                "keyword": "成型方式-V-cut",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "V-cut 角度",
            "category": "机加工",
            "description": "V-cut刀具的角度",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "V-cut 角度",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "V-cut 角度公差",
            "category": "机加工",
            "description": "",
            "type": "range",
            "unit": [],
            "expect": {
                "keyword": "V-cut 角度公差",
                "min": "",
                "max": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "V-cut 余厚",
            "category": "机加工",
            "description": "V-cut后保留的板材厚度",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "expect": {
                "keyword": "V-cut 余厚",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "V-cut 余厚公差",
            "category": "机加工",
            "description": "",
            "type": "range",
            "unit": [
                "mm"
            ],
            "expect": {
                "keyword": "V-cut 余厚公差",
                "min": "",
                "max": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "孔位偏差",
            "category": "机加工",
            "description": "钻孔位置与设计位置的偏移",
            "type": "range",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "expect": {
                "keyword": "孔位偏差",
                "min": "",
                "max": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "孔粗",
            "category": "机加工",
            "description": "孔壁粗糙度",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "孔粗",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "定位孔",
            "category": "机加工",
            "description": "用于PCB对位的基准孔",
            "type": "str",
            "expect": {
                "keyword": "",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "CAF 间距",
            "category": "机加工",
            "description": "导电阳极丝（离子迁移）的最小间距",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "CAF 间距",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "孔图",
            "category": "机加工",
            "description": "钻孔位置和尺寸的图纸文件",
            "type": "str",
            "expect": {
                "keyword": "孔图",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "沉头孔",
            "category": "机加工",
            "description": "螺钉头部沉入的锥形孔",
            "type": "str",
            "expect": {
                "keyword": "沉头孔",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "沉头孔属性",
            "category": "机加工",
            "description": "",
            "type": "enumeration",
            "enumeration": [
                "PTH",
                "NPTH"
            ],
            "expect": {
                "keyword": "沉头孔属性",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "沉头孔面向",
            "category": "机加工",
            "description": "沉头面朝向",
            "type": "str",
            "expect": {
                "keyword": "",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "沉头孔方式",
            "category": "机加工",
            "description": "",
            "type": "enumeration",
            "enumeration": [
                "钻沉头孔",
                "锣沉头孔"
            ],
            "expect": {
                "keyword": "沉头孔方式",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "压接孔",
            "category": "机加工",
            "description": "用于压接器件的过孔（无焊盘）",
            "type": "str",
            "expect": {
                "keyword": "",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "控深锣",
            "category": "机加工",
            "description": "控制深度的锣槽加工",
            "type": "str",
            "expect": {
                "keyword": "控深锣",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "盲槽方向",
            "category": "机加工",
            "description": "盲槽的加工方向",
            "type": "str",
            "expect": {
                "keyword": "盲槽方向",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "锣PTH",
            "category": "机加工",
            "description": "对镀通孔（PTH）进行锣槽加工",
            "type": "str",
            "expect": {
                "keyword": "锣PTH",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "超短槽",
            "category": "机加工",
            "description": "长度＜1mm的槽孔",
            "type": "str",
            "expect": {
                "keyword": "超短槽",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "＜0.5mm圆角孔",
            "category": "机加工",
            "description": "圆角半径＜0.5mm的异形孔",
            "type": "str",
            "expect": {
                "keyword": "＜0.5mm圆角孔",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "斜边",
            "category": "机加工",
            "description": "板边斜面加工",
            "type": "str",
            "expect": {
                "keyword": "斜边",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "斜边深度",
            "category": "机加工",
            "description": "斜边切除的厚度",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "expect": {
                "keyword": "斜边深度",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "斜边深度公差",
            "category": "机加工",
            "description": "",
            "type": "range",
            "unit": [],
            "expect": {
                "keyword": "斜边深度公差",
                "min": "",
                "max": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "角度公差",
            "category": "机加工",
            "description": "斜边角度的允许偏差",
            "type": "range",
            "unit": [],
            "expect": {
                "keyword": "角度公差",
                "min": "",
                "max": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "内层基铜",
            "category": "线路信息",
            "description": "内层初始铜箔厚度",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil",
                "oz"
            ],
            "expect": {
                "keyword": "内层基铜",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "内层最小完成铜厚",
            "category": "线路信息",
            "description": "蚀刻后内层铜厚最小值",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil",
                "oz"
            ],
            "expect": {
                "keyword": "内层最小完成铜厚",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "盲孔孔铜最小单点",
            "category": "线路信息",
            "description": "盲孔孔壁铜厚最薄处",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "盲孔孔铜最小单点",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "盲孔孔铜最小平均",
            "category": "线路信息",
            "description": "盲孔孔壁铜厚平均值",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "盲孔孔铜最小平均",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "内层最小焊环",
            "category": "线路信息",
            "description": "内层过孔焊盘剩余环宽",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "内层最小焊环",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "内层补线",
            "category": "线路信息",
            "description": "是否有修复内层断线的工艺",
            "type": "str",
            "expect": {
                "keyword": "内层补线",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "删除内层独立PAD",
            "category": "线路信息",
            "description": "是否允许移除无连接的内层焊盘（防虚焊）",
            "type": "str",
            "expect": {
                "keyword": "删除内层独立PAD",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "外层基铜",
            "category": "线路信息",
            "description": "外层初始铜箔厚度",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil",
                "oz"
            ],
            "expect": {
                "keyword": "外层基铜",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "外层最小完成铜厚",
            "category": "线路信息",
            "description": "蚀刻后外层铜厚最小值",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil",
                "oz"
            ],
            "expect": {
                "keyword": "外层最小完成铜厚",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "通孔孔铜最小单点",
            "category": "线路信息",
            "description": "通孔孔壁铜厚最薄处",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "通孔孔铜最小单点",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "通孔孔铜最小平均",
            "category": "线路信息",
            "description": "通孔孔壁铜厚平均值",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "通孔孔铜最小平均",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "外层线路线宽公差",
            "category": "线路信息",
            "description": "外层线路宽度允许偏差",
            "type": "range",
            "unit": [],
            "expect": {
                "keyword": "",
                "min": "",
                "max": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "内层线路线宽公差",
            "category": "线路信息",
            "description": "内层线路宽度允许偏差",
            "type": "range",
            "unit": [],
            "expect": {
                "keyword": "内层线路线宽公差",
                "min": "",
                "max": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "外层最小焊环",
            "category": "线路信息",
            "description": "外层过孔焊盘剩余环宽",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "外层最小焊环",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "NPTH孔到线",
            "category": "线路信息",
            "description": "非金属化孔与线路的最小间距",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "NPTH孔到线",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "环形线",
            "category": "线路信息",
            "description": "围绕过孔的环形走线",
            "type": "str",
            "expect": {
                "keyword": "环形线",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "环形线宽",
            "category": "线路信息",
            "description": "环形走线的宽度",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "环形线宽",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "残铜面积",
            "category": "线路信息",
            "description": "内层无铜区的最小面积要求",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "残铜面积",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "外层补线",
            "category": "线路信息",
            "description": "修复外层断线的工艺",
            "type": "str",
            "expect": {
                "keyword": "外层补线",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "键合工艺",
            "category": "线路信息",
            "description": "金线/铜线绑定IC的工艺",
            "type": "str",
            "expect": {
                "keyword": "键合工艺",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "绑定IC",
            "category": "线路信息",
            "description": "指定需键合工艺的IC位置",
            "type": "str",
            "expect": {
                "keyword": "绑定IC",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "外层最小线宽",
            "category": "线路信息",
            "description": "外层可加工的最小导线宽度",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "expect": {
                "keyword": "外层最小线宽",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "内层最小线宽",
            "category": "线路信息",
            "description": "内层可加工的最小导线宽度",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "expect": {
                "keyword": "内层最小线宽",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "外层最小线距",
            "category": "线路信息",
            "description": "外层导线间最小间距",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "expect": {
                "keyword": "外层最小线距",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "内层最小线距",
            "category": "线路信息",
            "description": "内层导线间最小间距",
            "type": "int",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "expect": {
                "keyword": "内层最小线距",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "最小IC",
            "category": "线路信息",
            "description": "最小集成电路焊盘尺寸",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "最小IC",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "最小SMD pitch",
            "category": "线路信息",
            "description": "表面贴装器件最小引脚间距",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "最小BGA",
            "category": "线路信息",
            "description": "最小BGA焊球直径",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "最小BGA pitch",
            "category": "线路信息",
            "description": "BGA焊球中心间距",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "最小BGA pitch",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "表面处理",
            "category": "线路信息",
            "description": "PCB焊盘表面工艺",
            "type": "str",
            "expect": {
                "keyword": "表面处理",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "沉锡厚度",
            "category": "线路信息",
            "description": "",
            "type": "range",
            "unit": [],
            "expect": {
                "keyword": "沉锡厚度",
                "min": "",
                "max": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "沉金厚度",
            "category": "线路信息",
            "description": "",
            "type": "range",
            "unit": [],
            "expect": {
                "keyword": "沉金厚度",
                "min": "",
                "max": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "沉金镍厚",
            "category": "线路信息",
            "description": "",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "沉金镍厚",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "沉银厚度",
            "category": "线路信息",
            "description": "",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "沉银厚度",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "喷锡厚度",
            "category": "线路信息",
            "description": "",
            "type": "range",
            "unit": [],
            "expect": {
                "keyword": "喷锡厚度",
                "min": "",
                "max": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "钯厚",
            "category": "线路信息",
            "description": "ENEPIG工艺中钯层厚度",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "钯厚",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "OSP厚度",
            "category": "线路信息",
            "description": "",
            "type": "range",
            "unit": [],
            "expect": {
                "keyword": "OSP厚度",
                "min": "",
                "max": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "A面沉金面积",
            "category": "线路信息",
            "description": "A面沉金处理区域占总面积比例",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "A面沉金面积",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "B面沉金面积",
            "category": "线路信息",
            "description": "B面沉金处理区域占总面积比例",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "B面沉金面积",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "镀金手指",
            "category": "线路信息",
            "description": "插接部位镀硬金",
            "type": "str",
            "expect": {
                "keyword": "镀金手指",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "镀金厚度",
            "category": "线路信息",
            "description": "",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "镀金厚度",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "镀金镍厚度",
            "category": "线路信息",
            "description": "",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "镀金镍厚度",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "A面镀金面积",
            "category": "线路信息",
            "description": "A面电镀金区域占比",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "A面镀金面积",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "B面镀金面积",
            "category": "线路信息",
            "description": "B面电镀金区域占比",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "B面镀金面积",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "A面阻焊颜色",
            "category": "阻焊字符",
            "description": "A面阻焊油墨颜色",
            "type": "str",
            "expect": {
                "keyword": "A面阻焊颜色",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "B面阻焊颜色",
            "category": "阻焊字符",
            "description": "B面阻焊油墨颜色",
            "type": "str",
            "expect": {
                "keyword": "B面阻焊颜色",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "A面阻焊型号",
            "category": "阻焊字符",
            "description": "A面阻焊油墨材料型号",
            "type": "str",
            "expect": {
                "keyword": "A面阻焊型号",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "B面阻焊型号",
            "category": "阻焊字符",
            "description": "B面阻焊油墨材料型号",
            "type": "str",
            "expect": {
                "keyword": "B面阻焊型号",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "铜面阻焊厚度",
            "category": "阻焊字符",
            "description": "",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "铜面阻焊厚度",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "拐角阻焊厚度",
            "category": "阻焊字符",
            "description": "板边/拐角处阻焊厚度",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "拐角阻焊厚度",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "线间阻焊厚度",
            "category": "阻焊字符",
            "description": "线路之间的阻焊覆盖厚度",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "线间阻焊厚度",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "塞孔阻焊厚度",
            "category": "阻焊字符",
            "description": "过孔塞油墨后的表面厚度",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "塞孔阻焊厚度",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "塞孔深度",
            "category": "阻焊字符",
            "description": "油墨塞入过孔的深度",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "塞孔深度",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "塞孔方式",
            "category": "阻焊字符",
            "description": "树脂塞孔、电镀填平、油墨塞孔",
            "type": "str",
            "expect": {
                "keyword": "塞孔方式",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "帽子电镀",
            "category": "阻焊字符",
            "description": "过孔孔口镀铜加厚（防爆孔）",
            "type": "str",
            "expect": {
                "keyword": "帽子电镀",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "树脂凹陷",
            "category": "阻焊字符",
            "description": "树脂填充后的表面凹陷深度",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "树脂凹陷",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "A面字符颜色",
            "category": "阻焊字符",
            "description": "A面丝印标识颜色（如白色、黄色）",
            "type": "str",
            "expect": {
                "keyword": "A面字符颜色",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "B面字符颜色",
            "category": "阻焊字符",
            "description": "B面丝印标识颜色（如白色、黄色）",
            "type": "str",
            "expect": {
                "keyword": "B面字符颜色",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "A面字符型号",
            "category": "阻焊字符",
            "description": "A面字符油墨型号",
            "type": "str",
            "expect": {
                "keyword": "A面字符型号",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "B面字符型号",
            "category": "阻焊字符",
            "description": "B面字符油墨型号",
            "type": "str",
            "expect": {
                "keyword": "B面字符型号",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "字符厚度",
            "category": "阻焊字符",
            "description": "",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "字符厚度",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "白油块厚度",
            "category": "阻焊字符",
            "description": "局部白色阻焊块的厚度",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "白油块用途",
            "category": "阻焊字符",
            "description": "用于标记或反射光信号",
            "type": "str",
            "expect": {
                "keyword": "白油块用途",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "二维码要求",
            "category": "阻焊字符",
            "description": "二维码内容、尺寸、精度等",
            "type": "str",
            "expect": {
                "keyword": "二维码要求",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "二维码规则",
            "category": "阻焊字符",
            "description": "二维码编码格式（如Data Matrix）。",
            "type": "str",
            "expect": {
                "keyword": "二维码规则",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "二维码类型",
            "category": "阻焊字符",
            "description": "激光雕刻、油墨印刷",
            "type": "str",
            "expect": {
                "keyword": "二维码类型",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "二维码生产方式",
            "category": "阻焊字符",
            "description": "LDI曝光、喷墨打印等",
            "type": "str",
            "expect": {
                "keyword": "二维码生产方式",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "UL logo",
            "category": "阻焊字符",
            "description": "UL认证标识的印刷要求",
            "type": "str",
            "expect": {
                "keyword": "UL logo",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "周期格式",
            "category": "阻焊字符",
            "description": "生产周期码的格式（如YYWW）",
            "type": "str",
            "expect": {
                "keyword": "周期格式",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "logo位置",
            "category": "阻焊字符",
            "description": "客户标识/UL标志的放置位置",
            "type": "str",
            "expect": {
                "keyword": "logo位置",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "蓝胶",
            "category": "阻焊字符",
            "description": "用于局部绝缘的蓝色阻焊材料",
            "type": "str",
            "expect": {
                "keyword": "蓝胶",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "蓝胶塞孔",
            "category": "阻焊字符",
            "description": "用蓝胶填充特定过孔",
            "type": "str",
            "expect": {
                "keyword": "蓝胶塞孔",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "蓝胶面向",
            "category": "阻焊字符",
            "description": "蓝胶施加面（A/B面）。",
            "type": "str",
            "expect": {
                "keyword": "蓝胶面向",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "蓝胶厚度",
            "category": "阻焊字符",
            "description": "",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "蓝胶厚度",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "蓝胶型号",
            "category": "阻焊字符",
            "description": "",
            "type": "str",
            "expect": {
                "keyword": "蓝胶型号",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "碳油",
            "category": "阻焊字符",
            "description": "导电碳浆印刷",
            "type": "str",
            "expect": {
                "keyword": "碳油",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "碳油面向",
            "category": "阻焊字符",
            "description": "碳油印刷面（A/B面）",
            "type": "str",
            "expect": {
                "keyword": "碳油面向",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "碳油厚度",
            "category": "阻焊字符",
            "description": "",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "碳油厚度",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "碳油型号",
            "category": "阻焊字符",
            "description": "",
            "type": "str",
            "expect": {
                "keyword": "碳油型号",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "碳油阻值",
            "category": "阻焊字符",
            "description": "碳膜电阻值",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "碳油方阻",
            "category": "阻焊字符",
            "description": "单位面积电阻值",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "碳油方阻",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "黄金胶",
            "category": "阻焊字符",
            "description": "含金填料的导电胶（高频应用）",
            "type": "str",
            "expect": {
                "keyword": "黄金胶",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "黄金胶面向",
            "category": "阻焊字符",
            "description": "",
            "type": "str",
            "expect": {
                "keyword": "黄金胶面向",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "黄金胶类型",
            "category": "阻焊字符",
            "description": "",
            "type": "str",
            "expect": {
                "keyword": "黄金胶类型",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "包装块数",
            "category": "包装要求",
            "description": "每包/箱的PCB数量。",
            "type": "int",
            "unit": [],
            "expect": {
                "keyword": "包装块数",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "干燥剂",
            "category": "包装要求",
            "description": "防潮包装用吸湿剂",
            "type": "str",
            "expect": {
                "keyword": "干燥剂",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "湿度卡",
            "category": "包装要求",
            "description": "监测包装内湿度的指示卡",
            "type": "str",
            "expect": {
                "keyword": "湿度卡",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "气泡膜",
            "category": "包装要求",
            "description": "防震包装材料",
            "type": "str",
            "expect": {
                "keyword": "气泡膜",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "防静电真空包装",
            "category": "包装要求",
            "description": "ESD防护+真空密封",
            "type": "str",
            "expect": {
                "keyword": "防静电真空包装",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "PE袋包装",
            "category": "包装要求",
            "description": "防静电聚乙烯袋",
            "type": "str",
            "expect": {
                "keyword": "PE袋包装",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "铝箔袋包装",
            "category": "包装要求",
            "description": "防潮防静电铝箔袋",
            "type": "str",
            "expect": {
                "keyword": "铝箔袋包装",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "隔白纸要求",
            "category": "包装要求",
            "description": "PCB间隔离用白纸（无硫）",
            "type": "str",
            "expect": {
                "keyword": "隔白纸要求",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "隔无硫纸要求",
            "category": "包装要求",
            "description": "防止硫腐蚀的隔离纸",
            "type": "str",
            "expect": {
                "keyword": "隔无硫纸要求",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "特殊纸箱规格",
            "category": "包装要求",
            "description": "定制包装箱尺寸/材质。",
            "type": "str",
            "expect": {
                "keyword": "特殊纸箱规格",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "填充物",
            "category": "包装要求",
            "description": "箱内防震填充材料（如泡沫）",
            "type": "str",
            "expect": {
                "keyword": "填充物",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "垫板要求",
            "category": "包装要求",
            "description": "箱内底部支撑板（防变形）。",
            "type": "str",
            "expect": {
                "keyword": "垫板要求",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "备品要求",
            "category": "包装要求",
            "description": "额外提供的备用PCB数量。",
            "type": "str",
            "expect": {
                "keyword": "备品要求",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "客户型号",
            "category": "基础信息",
            "description": "客户提供的pcb订单产品型号。",
            "type": "str",
            "expect": {
                "keyword": "客户型号",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "客户型号版本号",
            "category": "基础信息",
            "description": "产品型号的版本号。",
            "type": "str",
            "expect": {
                "keyword": "客户型号版本号",
                "value": "",
                "unit": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "终端型号",
            "category": "基础信息",
            "description": "",
            "type": "str",
            "expect": {
                "keyword": "终端型号",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "终端版本号",
            "category": "基础信息",
            "description": "",
            "type": "str",
            "expect": {
                "keyword": "终端版本号",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "Your RFQ",
            "category": "基础信息",
            "description": "",
            "type": "str",
            "expect": {
                "keyword": "Your RFQ",
                "value": "",
                "sourceText": ""
            }
        },
        {
            "keyword": "层压结构备注",
            "category": "基础信息",
            "description": "在层压结构的文件内提取层压结构相关的备注要求",
            "type": "text",
            "expect": [
                {
                    "keyword": "层压结构备注",
                    "value": "",
                    "sourceText": ""
                }
            ]
        },
        {
            "keyword": "阻抗备注",
            "category": "基础信息",
            "description": "在阻抗数据的文件内提取阻抗相关的备注要求",
            "type": "text",
            "expect": [
                {
                    "keyword": "阻抗备注",
                    "value": "",
                    "sourceText": ""
                }
            ]
        },
        {
            "keyword": "eng备注",
            "category": "基础信息",
            "description": "从eng文件中提取的所有客户要求内容",
            "type": "text",
            "expect": [
                {
                    "keyword": "eng备注",
                    "value": "",
                    "sourceText": ""
                }
            ]
        },
        {
            "keyword": "ecn备注",
            "category": "基础信息",
            "description": "从ecn文件中提取客户工程变更通知的内容，一般包含修改前的工程要求以及修改后的工程要求",
            "type": "text",
            "expect": [
                {
                    "keyword": "ecn备注",
                    "value": "",
                    "sourceText": ""
                }
            ]
        },
        {
            "keyword": "sow备注",
            "category": "基础信息",
            "description": "SOW文件可能包含版本变更要点，清洗对比新旧版本的差异‘核心制造要求’：工程要求，包装要求，质量与报告要求，物流要求等模块‘工程要求’：核心包括pcb制造基本参数，制造基本要求，特殊工艺细节要求等",
            "type": "text",
            "expect": [
                {
                    "keyword": "sow备注",
                    "value": "",
                    "sourceText": ""
                }
            ]
        },
        {
            "keyword": "spec备注",
            "category": "基础信息",
            "description": "从SPEC文件中提取的备注要求",
            "type": "text",
            "expect": [
                {
                    "keyword": "spec备注",
                    "value": "",
                    "sourceText": ""
                }
            ]
        },
        {
            "keyword": "压合结构",
            "type": "table",
            "category": "压合结构",
            "description": "`铜箔类型`: 仅对铜层有效，如 HTE (高温高延伸性铜箔)，RTF (反转处理铜箔),STD 等。若无则为空;`物料`: 该层的材料类型，如 PP, Core,Copper`板芯是否含铜`: 仅对Core层有效，判断该板芯两侧是否自带铜箔。`介质厚度公差`: 仅对介质层有效，其厚度公差，如 +/- 10%",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "fields": [
                "层名",
                "物料",
                "铜箔类型",
                "介质",
                "含铜",
                "残铜率(%)",
                "厚度",
                "厚度单位",
                "介质厚度公差",
                "sourceText"
            ],
            "expect": [
                {
                    "层名": "",
                    "物料": "",
                    "铜箔类型": "",
                    "介质": "",
                    "含铜": "",
                    "残铜率(%)": "",
                    "厚度": "",
                    "厚度单位": "",
                    "介质厚度公差": "",
                    "sourceText": ""
                }
            ]
        },
        {
            "keyword": "阻抗数据",
            "type": "table",
            "category": "阻抗数据",
            "description": "‘阻抗类型’：区分是单端阻抗还是差分阻抗。‘控制层’：代表阻抗所在层。‘参考层’：分为上参考层和下参考层",
            "unit": [
                "mm",
                "um",
                "mil"
            ],
            "fields": [
                "阻抗类型",
                "控制层",
                "上参考层",
                "下参考层",
                "线宽",
                "线距",
                "线到铜距离",
                "阻抗要求",
                "阻抗公差",
                "sourceText"
            ],
            "expect": [
                {
                    "阻抗类型": "",
                    "控制层": "",
                    "上参考层": "",
                    "下参考层": "",
                    "线宽": "",
                    "线距": "",
                    "线到铜距离": "",
                    "阻抗要求": "",
                    "阻抗公差": "",
                    "sourceText": ""
                }
            ]
        }
    ],
    "label_to_param_config": {
        "客户订单": {
            "params": [
                "客户型号",
                "终端型号",
                "Your RFQ"
            ],
            "prompt": "你是一位精通PCB供应链管理的专家，擅长从采购订单PO文件中精确提取关键信息,现在需要你从PO文件中提取出相关参数，在分析内容后输出答案，并遵循以下要求：\n1、以下是一份提取的要求配置，请参考配置并按照对应项的expect格式输出对应json：\n[{'keyword': '客户型号', 'category': '基础信息', 'description': '客户提供的pcb订单产品型号。', 'type': 'str', 'expect': {'keyword': '客户型号', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '终端型号', 'category': '基础信息', 'description': '', 'type': 'str', 'expect': {'keyword': '终端型号', 'value': '', 'sourceText': ''}}, {'keyword': 'Your RFQ', 'category': '基础信息', 'description': '', 'type': 'str', 'expect': {'keyword': 'Your RFQ', 'value': '', 'sourceText': ''}}]\n2、ocr会存在模糊，所以当你发现ocr与图片信息有差异时，value信息以图片为准，sourceText以ocr为准且不得更改原文内容和顺序，因为我需要根据ocr原文片段去识别文字所在坐标3、将最终json答案放入box标签中，同时使用对象json结构以便于使用JSON.parse的方式提取结果，期望格式：<box>\n{\"客户型号\": expect, \"终端型号\": expect,\"Your RFQ\":expect}\n</box>",
            "position": "common",
            "not_null": true,
            "only_one": false
        },
        "ENG文件": {
            "params": [
                "eng备注"
            ],
            "prompt": "你是一位精通PCB辅助制造的专家，能够准确解读客户的工程制造要求,现在需要你从eng文件中提取出相关参数，在分析内容后输出答案，并遵循以下要求：\n1、以下是一份提取的要求配置，请参考配置并按照对应项的expect格式输出对应json：\n[{'keyword': 'eng备注', 'category': '基础信息', 'description': '从eng文件中提取的所有客户要求内容', 'type': 'text', 'expect': [{'keyword': 'eng备注', 'value': '', 'sourceText': ''}]}]\n2、客户要求的eng备注可能有多项，它的expect结构是一个数组，备注value字段输出为中文；ocr会存在模糊，所以当你发现ocr与图片信息有差异时，value信息以图片为准，sourceText以ocr为准且不得更改原文内容，因为我需要根据ocr原文片段去识别文字所在坐标3、将最终json答案放入box标签中，同时使用对象json结构以便于使用JSON.parse的方式提取结果，期望格式：<box>\n{\"eng备注\": expect}\n</box>",
            "position": "common",
            "not_null": true,
            "only_one": false
        },
        "ECN文件": {
            "params": [
                "ecn备注"
            ],
            "prompt": "你是一位精通PCB辅助制造的专家，能够准确解读客户的工程制造要求,现在需要你从ecn文件中提取出相关参数，在分析内容后输出答案，并遵循以下要求：\n1、以下是一份提取的要求配置，请参考配置并按照对应项的expect格式输出对应json：\n[{'keyword': 'ecn备注', 'category': '基础信息', 'description': '从ecn文件中提取客户工程变更通知的内容，一般包含修改前的工程要求以及修改后的工程要求', 'type': 'text', 'expect': [{'keyword': 'ecn备注', 'value': '', 'sourceText': ''}]}]\n2、客户要求的ecn备注可能有多项，它的expect结构是一个数组，备注value字段输出为中文；ocr会存在模糊，所以当你发现ocr与图片信息有差异时，value信息以图片为准，sourceText以ocr为准且不得更改原文内容，因为我需要根据ocr原文片段去识别文字所在坐标3、将最终json答案放入box标签中，同时使用对象json结构以便于使用JSON.parse的方式提取结果，期望格式：<box>\n{\"ecn备注\": expect}\n</box>",
            "position": "common",
            "not_null": true,
            "only_one": false
        },
        "SOW文件": {
            "params": [
                "sow备注"
            ],
            "prompt": "你是一位精通PCB辅助制造的专家，你的专长是快速解读来自客户的制造规格文件（SOW），并将其转化为清晰、可执行的生产指令和要点。现在需要你从ecn文件中提取出相关参数，在分析内容后输出答案，并遵循以下要求：\n1、以下是一份提取的要求配置，请参考配置并按照对应项的expect格式输出对应json：\n[{'keyword': 'sow备注', 'category': '基础信息', 'description': 'SOW文件可能包含版本变更要点，清洗对比新旧版本的差异‘核心制造要求’：工程要求，包装要求，质量与报告要求，物流要求等模块‘工程要求’：核心包括pcb制造基本参数，制造基本要求，特殊工艺细节要求等', 'type': 'text', 'expect': [{'keyword': 'sow备注', 'value': '', 'sourceText': ''}]}]\n2、客户要求的sow备注可能有多项，它的expect结构是一个数组，备注value字段输出为中文；ocr会存在模糊，所以当你发现ocr与图片信息有差异时，value信息以图片为准，sourceText以ocr为准且不得更改原文内容，因为我需要根据ocr原文片段去识别文字所在坐标3、将最终json答案放入box标签中，同时使用对象json结构以便于使用JSON.parse的方式提取结果，期望格式：<box>\n{\"sow备注\": expect}\n</box>",
            "position": "common",
            "not_null": true,
            "only_one": false
        },
        "SPEC文件": {
            "params": [
                "拼板单位",
                "成品板厚",
                "成品板厚公差",
                "产品阶数",
                "pcs长",
                "pcs宽",
                "set长",
                "set宽",
                "pcs在ser中数量",
                "成型公差",
                "板子结构",
                "检验标准",
                "高压测试",
                "APQP",
                "PPAP",
                "IMDS",
                "CAMDS",
                "TG",
                "CTI",
                "板材类型",
                "板材颜色",
                "板材水印",
                "板材型号",
                "板弯板翘",
                "无卤素",
                "叉板",
                "叉板数量",
                "叉位种数",
                "叉板比例",
                "离子污染",
                "成型方式-锣板",
                "成型方式-冲板",
                "成型方式-V-cut",
                "V-cut 角度",
                "V-cut 角度公差",
                "V-cut 余厚",
                "V-cut 余厚公差",
                "孔位偏差",
                "孔粗",
                "定位孔",
                "CAF 间距",
                "孔图",
                "沉头孔",
                "沉头孔属性",
                "沉头孔面向",
                "沉头孔方式",
                "压接孔",
                "控深锣",
                "盲槽方向",
                "锣PTH",
                "超短槽",
                "＜0.5mm圆角孔",
                "斜边",
                "斜边深度",
                "斜边深度公差",
                "角度公差",
                "内层基铜",
                "内层最小完成铜厚",
                "盲孔孔铜最小单点",
                "盲孔孔铜最小平均",
                "内层最小焊环",
                "内层补线",
                "删除内层独立PAD",
                "外层基铜",
                "外层最小完成铜厚",
                "通孔孔铜最小单点",
                "通孔孔铜最小平均",
                "外层线路线宽公差",
                "内层线路线宽公差",
                "外层最小焊环",
                "NPTH孔到线",
                "环形线",
                "环形线宽",
                "残铜面积",
                "外层补线",
                "键合工艺",
                "绑定IC",
                "外层最小线宽",
                "内层最小线宽",
                "外层最小线距",
                "内层最小线距",
                "最小IC",
                "最小SMD pitch",
                "最小BGA",
                "最小BGA pitch",
                "表面处理",
                "沉锡厚度",
                "沉金厚度",
                "沉金镍厚",
                "沉银厚度",
                "喷锡厚度",
                "钯厚",
                "OSP厚度",
                "A面沉金面积",
                "B面沉金面积",
                "镀金手指",
                "镀金厚度",
                "镀金镍厚度",
                "A面镀金面积",
                "B面镀金面积",
                "A面阻焊颜色",
                "B面阻焊颜色",
                "A面阻焊型号",
                "B面阻焊型号",
                "铜面阻焊厚度",
                "拐角阻焊厚度",
                "线间阻焊厚度",
                "塞孔阻焊厚度",
                "塞孔深度",
                "塞孔方式",
                "帽子电镀",
                "树脂凹陷",
                "A面字符颜色",
                "B面字符颜色",
                "A面字符型号",
                "B面字符型号",
                "字符厚度",
                "白油块厚度",
                "白油块用途",
                "二维码要求",
                "二维码规则",
                "二维码类型",
                "二维码生产方式",
                "UL logo",
                "周期格式",
                "logo位置",
                "蓝胶",
                "蓝胶塞孔",
                "蓝胶面向",
                "蓝胶厚度",
                "蓝胶型号",
                "碳油",
                "碳油面向",
                "碳油厚度",
                "碳油型号",
                "碳油阻值",
                "碳油方阻",
                "黄金胶",
                "黄金胶面向",
                "黄金胶类型",
                "包装块数",
                "干燥剂",
                "湿度卡",
                "气泡膜",
                "防静电真空包装",
                "PE袋包装",
                "铝箔袋包装",
                "隔白纸要求",
                "隔无硫纸要求",
                "特殊纸箱规格",
                "填充物",
                "垫板要求",
                "备品要求"
            ],
            "prompt": "你是一个pcb辅助制造的专家，专注于pcb的制前处理检查， 现在需要对客户给出的文件进行参数检查，现在需要你经过分析后提取出各项参数的值，检查项如下：\n[{'keyword': '拼板单位', 'category': '基础信息', 'description': '生产时多个单板（PCS）组成的集合单元（SET）', 'type': 'str', 'expect': {'keyword': '拼板单位', 'value': '', 'sourceText': ''}}, {'keyword': '成品板厚', 'category': '基础信息', 'description': 'PCB电路板生产最终成品的板厚', 'type': 'int', 'unit': ['mm', 'um', 'mil'], 'expect': {'keyword': '成品板厚', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '成品板厚公差', 'category': '基础信息', 'description': 'PCB电路板生产最终成品的板厚允许的厚度偏差范围', 'type': 'range', 'unit': [], 'expect': {'keyword': '成品板厚公差', 'min': '', 'max': '', 'unit': '', 'sourceText': ''}}, {'keyword': '产品阶数', 'category': '基础信息', 'description': '', 'type': 'str', 'expect': {'keyword': '产品阶数', 'value': '', 'sourceText': ''}}, {'keyword': 'pcs长', 'category': '基础信息', 'description': 'PCB制造时单板pcs的长度尺寸', 'type': 'int', 'unit': ['mm', 'um', 'mil'], 'expect': {'keyword': 'pcs长', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'pcs宽', 'category': '基础信息', 'description': 'PCB制造时单板pcs的宽度尺寸', 'type': 'int', 'unit': ['mm', 'um', 'mil'], 'expect': {'keyword': 'pcs宽', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'set长', 'category': '基础信息', 'description': 'PCB制造时拼板set的长度尺寸', 'type': 'int', 'unit': ['mm', 'um', 'mil'], 'expect': {'keyword': 'set长', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'set宽', 'category': '基础信息', 'description': 'PCB制造时拼板set的长度尺寸', 'type': 'int', 'unit': ['mm', 'um', 'mil'], 'expect': {'keyword': 'set宽', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'pcs在ser中数量', 'category': '基础信息', 'description': '单个拼板set包含的单板pcs数量', 'type': 'int', 'unit': [], 'expect': {'keyword': 'pcs在ser中数量', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '成型公差', 'category': '基础信息', 'description': '外形加工（锣板/冲板）的尺寸偏差', 'type': 'range', 'unit': ['mm', 'um', 'mil'], 'expect': {'keyword': '成型公差', 'min': '', 'max': '', 'unit': '', 'sourceText': ''}}, {'keyword': '板子结构', 'category': '基础信息', 'description': '', 'type': 'str', 'expect': {'keyword': '', 'value': '', 'sourceText': ''}}, {'keyword': '检验标准', 'category': '基础信息', 'description': '国际电子工业联接协会制定的PCB制造与验收标准', 'type': 'enumeration', 'enumeration': ['class1', 'class2', 'class3'], 'expect': {'keyword': '检验标准', 'value': '', 'sourceText': ''}}, {'keyword': '高压测试', 'category': '基础信息', 'description': '施加高电压检测绝缘性能', 'type': 'int', 'unit': ['VDC', 'VAC'], 'expect': {'keyword': '高压测试', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'APQP', 'category': '基础信息', 'description': '汽车行业先期产品质量策划流程,确保产品从设计到量产的可靠性', 'type': 'str', 'expect': {'keyword': 'APQP', 'value': '', 'sourceText': ''}}, {'keyword': 'PPAP', 'category': '基础信息', 'description': '生产件批准程序（汽车行业必备）', 'type': 'str', 'expect': {'keyword': 'PPAP', 'value': '', 'sourceText': ''}}, {'keyword': 'IMDS', 'category': '基础信息', 'description': '国际材料数据系统（用于环保合规）', 'type': 'str', 'expect': {'keyword': 'IMDS', 'value': '', 'sourceText': ''}}, {'keyword': 'CAMDS', 'category': '基础信息', 'description': '中国汽车材料数据系统（类似IMDS）', 'type': 'str', 'expect': {'keyword': 'CAMDS', 'value': '', 'sourceText': ''}}, {'keyword': 'TG', 'category': '基础信息', 'description': '基材玻璃化转变温度', 'type': 'int', 'unit': ['℃'], 'expect': {'keyword': '', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'CTI', 'category': '基础信息', 'description': '耐漏电起痕指数,用于评估绝缘材料在潮湿和污染条件下的耐电痕化能力', 'type': 'int', 'unit': ['V'], 'expect': {'keyword': '', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '板材类型', 'category': '基础信息', 'description': 'PCB板基材种类', 'type': 'str', 'expect': {'keyword': '板材类型', 'value': '', 'sourceText': ''}}, {'keyword': '板材颜色', 'category': '基础信息', 'description': '基材本体的颜色', 'type': 'str', 'expect': {'keyword': '板材颜色', 'value': '', 'sourceText': ''}}, {'keyword': '板材水印', 'category': '基础信息', 'description': '基材上的制造商标识或者认证标记', 'type': 'str', 'expect': {'keyword': '板材水印', 'value': '', 'sourceText': ''}}, {'keyword': '板材型号', 'category': '基础信息', 'description': '具体的材料型号', 'type': 'str', 'expect': {'keyword': '板材型号', 'value': '', 'sourceText': ''}}, {'keyword': '板弯板翘', 'category': '基础信息', 'description': 'PCB电路板平面度偏差', 'type': 'int', 'unit': [], 'expect': {'keyword': '板弯板翘', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '无卤素', 'category': '基础信息', 'description': '材料中卤素含量≤900ppm（环保要求）', 'type': 'str', 'expect': {'keyword': '无卤素', 'value': '', 'sourceText': ''}}, {'keyword': '叉板', 'category': '基础信息', 'description': '拼板中用于分割的辅助小板。', 'type': 'str', 'expect': {'keyword': '叉板', 'value': '', 'sourceText': ''}}, {'keyword': '叉板数量', 'category': '基础信息', 'description': '单个拼板中叉板的数量。', 'type': 'int', 'unit': [], 'expect': {'keyword': '叉板数量', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '叉位种数', 'category': '基础信息', 'description': '叉板的设计种类数（如不同形状）。', 'type': 'int', 'unit': [], 'expect': {'keyword': '叉位种数', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '叉板比例', 'category': '基础信息', 'description': '叉板面积占拼板总面积的比例。', 'type': 'int', 'unit': [], 'expect': {'keyword': '', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '离子污染', 'category': '基础信息', 'description': '表面残留离子浓度', 'type': 'str', 'expect': {'keyword': '', 'value': '', 'sourceText': ''}}, {'keyword': '成型方式-锣板', 'category': '机加工', 'description': '使用CNC锣机切割外形', 'type': 'str', 'expect': {'keyword': '成型方式-锣板', 'value': '', 'sourceText': ''}}, {'keyword': '成型方式-冲板', 'category': '机加工', 'description': '使用模具冲压成型', 'type': 'str', 'expect': {'keyword': '成型方式-冲板', 'value': '', 'sourceText': ''}}, {'keyword': '成型方式-V-cut', 'category': '机加工', 'description': 'V型槽分割拼板。', 'type': 'str', 'expect': {'keyword': '成型方式-V-cut', 'value': '', 'sourceText': ''}}, {'keyword': 'V-cut 角度', 'category': '机加工', 'description': 'V-cut刀具的角度', 'type': 'int', 'unit': [], 'expect': {'keyword': 'V-cut 角度', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'V-cut 角度公差', 'category': '机加工', 'description': '', 'type': 'range', 'unit': [], 'expect': {'keyword': 'V-cut 角度公差', 'min': '', 'max': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'V-cut 余厚', 'category': '机加工', 'description': 'V-cut后保留的板材厚度', 'type': 'int', 'unit': ['mm', 'um', 'mil'], 'expect': {'keyword': 'V-cut 余厚', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'V-cut 余厚公差', 'category': '机加工', 'description': '', 'type': 'range', 'unit': ['mm'], 'expect': {'keyword': 'V-cut 余厚公差', 'min': '', 'max': '', 'unit': '', 'sourceText': ''}}, {'keyword': '孔位偏差', 'category': '机加工', 'description': '钻孔位置与设计位置的偏移', 'type': 'range', 'unit': ['mm', 'um', 'mil'], 'expect': {'keyword': '孔位偏差', 'min': '', 'max': '', 'unit': '', 'sourceText': ''}}, {'keyword': '孔粗', 'category': '机加工', 'description': '孔壁粗糙度', 'type': 'int', 'unit': [], 'expect': {'keyword': '孔粗', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '定位孔', 'category': '机加工', 'description': '用于PCB对位的基准孔', 'type': 'str', 'expect': {'keyword': '', 'value': '', 'sourceText': ''}}, {'keyword': 'CAF 间距', 'category': '机加工', 'description': '导电阳极丝（离子迁移）的最小间距', 'type': 'int', 'unit': [], 'expect': {'keyword': 'CAF 间距', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '孔图', 'category': '机加工', 'description': '钻孔位置和尺寸的图纸文件', 'type': 'str', 'expect': {'keyword': '孔图', 'value': '', 'sourceText': ''}}, {'keyword': '沉头孔', 'category': '机加工', 'description': '螺钉头部沉入的锥形孔', 'type': 'str', 'expect': {'keyword': '沉头孔', 'value': '', 'sourceText': ''}}, {'keyword': '沉头孔属性', 'category': '机加工', 'description': '', 'type': 'enumeration', 'enumeration': ['PTH', 'NPTH'], 'expect': {'keyword': '沉头孔属性', 'value': '', 'sourceText': ''}}, {'keyword': '沉头孔面向', 'category': '机加工', 'description': '沉头面朝向', 'type': 'str', 'expect': {'keyword': '', 'value': '', 'sourceText': ''}}, {'keyword': '沉头孔方式', 'category': '机加工', 'description': '', 'type': 'enumeration', 'enumeration': ['钻沉头孔', '锣沉头孔'], 'expect': {'keyword': '沉头孔方式', 'value': '', 'sourceText': ''}}, {'keyword': '压接孔', 'category': '机加工', 'description': '用于压接器件的过孔（无焊盘）', 'type': 'str', 'expect': {'keyword': '', 'value': '', 'sourceText': ''}}, {'keyword': '控深锣', 'category': '机加工', 'description': '控制深度的锣槽加工', 'type': 'str', 'expect': {'keyword': '控深锣', 'value': '', 'sourceText': ''}}, {'keyword': '盲槽方向', 'category': '机加工', 'description': '盲槽的加工方向', 'type': 'str', 'expect': {'keyword': '盲槽方向', 'value': '', 'sourceText': ''}}, {'keyword': '锣PTH', 'category': '机加工', 'description': '对镀通孔（PTH）进行锣槽加工', 'type': 'str', 'expect': {'keyword': '锣PTH', 'value': '', 'sourceText': ''}}, {'keyword': '超短槽', 'category': '机加工', 'description': '长度＜1mm的槽孔', 'type': 'str', 'expect': {'keyword': '超短槽', 'value': '', 'sourceText': ''}}, {'keyword': '＜0.5mm圆角孔', 'category': '机加工', 'description': '圆角半径＜0.5mm的异形孔', 'type': 'str', 'expect': {'keyword': '＜0.5mm圆角孔', 'value': '', 'sourceText': ''}}, {'keyword': '斜边', 'category': '机加工', 'description': '板边斜面加工', 'type': 'str', 'expect': {'keyword': '斜边', 'value': '', 'sourceText': ''}}, {'keyword': '斜边深度', 'category': '机加工', 'description': '斜边切除的厚度', 'type': 'int', 'unit': ['mm', 'um', 'mil'], 'expect': {'keyword': '斜边深度', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '斜边深度公差', 'category': '机加工', 'description': '', 'type': 'range', 'unit': [], 'expect': {'keyword': '斜边深度公差', 'min': '', 'max': '', 'unit': '', 'sourceText': ''}}, {'keyword': '角度公差', 'category': '机加工', 'description': '斜边角度的允许偏差', 'type': 'range', 'unit': [], 'expect': {'keyword': '角度公差', 'min': '', 'max': '', 'unit': '', 'sourceText': ''}}, {'keyword': '内层基铜', 'category': '线路信息', 'description': '内层初始铜箔厚度', 'type': 'int', 'unit': ['mm', 'um', 'mil', 'oz'], 'expect': {'keyword': '内层基铜', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '内层最小完成铜厚', 'category': '线路信息', 'description': '蚀刻后内层铜厚最小值', 'type': 'int', 'unit': ['mm', 'um', 'mil', 'oz'], 'expect': {'keyword': '内层最小完成铜厚', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '盲孔孔铜最小单点', 'category': '线路信息', 'description': '盲孔孔壁铜厚最薄处', 'type': 'int', 'unit': [], 'expect': {'keyword': '盲孔孔铜最小单点', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '盲孔孔铜最小平均', 'category': '线路信息', 'description': '盲孔孔壁铜厚平均值', 'type': 'int', 'unit': [], 'expect': {'keyword': '盲孔孔铜最小平均', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '内层最小焊环', 'category': '线路信息', 'description': '内层过孔焊盘剩余环宽', 'type': 'int', 'unit': [], 'expect': {'keyword': '内层最小焊环', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '内层补线', 'category': '线路信息', 'description': '是否有修复内层断线的工艺', 'type': 'str', 'expect': {'keyword': '内层补线', 'value': '', 'sourceText': ''}}, {'keyword': '删除内层独立PAD', 'category': '线路信息', 'description': '是否允许移除无连接的内层焊盘（防虚焊）', 'type': 'str', 'expect': {'keyword': '删除内层独立PAD', 'value': '', 'sourceText': ''}}, {'keyword': '外层基铜', 'category': '线路信息', 'description': '外层初始铜箔厚度', 'type': 'int', 'unit': ['mm', 'um', 'mil', 'oz'], 'expect': {'keyword': '外层基铜', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '外层最小完成铜厚', 'category': '线路信息', 'description': '蚀刻后外层铜厚最小值', 'type': 'int', 'unit': ['mm', 'um', 'mil', 'oz'], 'expect': {'keyword': '外层最小完成铜厚', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '通孔孔铜最小单点', 'category': '线路信息', 'description': '通孔孔壁铜厚最薄处', 'type': 'int', 'unit': [], 'expect': {'keyword': '通孔孔铜最小单点', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '通孔孔铜最小平均', 'category': '线路信息', 'description': '通孔孔壁铜厚平均值', 'type': 'int', 'unit': [], 'expect': {'keyword': '通孔孔铜最小平均', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '外层线路线宽公差', 'category': '线路信息', 'description': '外层线路宽度允许偏差', 'type': 'range', 'unit': [], 'expect': {'keyword': '', 'min': '', 'max': '', 'unit': '', 'sourceText': ''}}, {'keyword': '内层线路线宽公差', 'category': '线路信息', 'description': '内层线路宽度允许偏差', 'type': 'range', 'unit': [], 'expect': {'keyword': '内层线路线宽公差', 'min': '', 'max': '', 'unit': '', 'sourceText': ''}}, {'keyword': '外层最小焊环', 'category': '线路信息', 'description': '外层过孔焊盘剩余环宽', 'type': 'int', 'unit': [], 'expect': {'keyword': '外层最小焊环', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'NPTH孔到线', 'category': '线路信息', 'description': '非金属化孔与线路的最小间距', 'type': 'int', 'unit': [], 'expect': {'keyword': 'NPTH孔到线', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '环形线', 'category': '线路信息', 'description': '围绕过孔的环形走线', 'type': 'str', 'expect': {'keyword': '环形线', 'value': '', 'sourceText': ''}}, {'keyword': '环形线宽', 'category': '线路信息', 'description': '环形走线的宽度', 'type': 'int', 'unit': [], 'expect': {'keyword': '环形线宽', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '残铜面积', 'category': '线路信息', 'description': '内层无铜区的最小面积要求', 'type': 'int', 'unit': [], 'expect': {'keyword': '残铜面积', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '外层补线', 'category': '线路信息', 'description': '修复外层断线的工艺', 'type': 'str', 'expect': {'keyword': '外层补线', 'value': '', 'sourceText': ''}}, {'keyword': '键合工艺', 'category': '线路信息', 'description': '金线/铜线绑定IC的工艺', 'type': 'str', 'expect': {'keyword': '键合工艺', 'value': '', 'sourceText': ''}}, {'keyword': '绑定IC', 'category': '线路信息', 'description': '指定需键合工艺的IC位置', 'type': 'str', 'expect': {'keyword': '绑定IC', 'value': '', 'sourceText': ''}}, {'keyword': '外层最小线宽', 'category': '线路信息', 'description': '外层可加工的最小导线宽度', 'type': 'int', 'unit': ['mm', 'um', 'mil'], 'expect': {'keyword': '外层最小线宽', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '内层最小线宽', 'category': '线路信息', 'description': '内层可加工的最小导线宽度', 'type': 'int', 'unit': ['mm', 'um', 'mil'], 'expect': {'keyword': '内层最小线宽', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '外层最小线距', 'category': '线路信息', 'description': '外层导线间最小间距', 'type': 'int', 'unit': ['mm', 'um', 'mil'], 'expect': {'keyword': '外层最小线距', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '内层最小线距', 'category': '线路信息', 'description': '内层导线间最小间距', 'type': 'int', 'unit': ['mm', 'um', 'mil'], 'expect': {'keyword': '内层最小线距', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '最小IC', 'category': '线路信息', 'description': '最小集成电路焊盘尺寸', 'type': 'int', 'unit': [], 'expect': {'keyword': '最小IC', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '最小SMD pitch', 'category': '线路信息', 'description': '表面贴装器件最小引脚间距', 'type': 'int', 'unit': [], 'expect': {'keyword': '', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '最小BGA', 'category': '线路信息', 'description': '最小BGA焊球直径', 'type': 'int', 'unit': [], 'expect': {'keyword': '', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '最小BGA pitch', 'category': '线路信息', 'description': 'BGA焊球中心间距', 'type': 'int', 'unit': [], 'expect': {'keyword': '最小BGA pitch', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '表面处理', 'category': '线路信息', 'description': 'PCB焊盘表面工艺', 'type': 'str', 'expect': {'keyword': '表面处理', 'value': '', 'sourceText': ''}}, {'keyword': '沉锡厚度', 'category': '线路信息', 'description': '', 'type': 'range', 'unit': [], 'expect': {'keyword': '沉锡厚度', 'min': '', 'max': '', 'unit': '', 'sourceText': ''}}, {'keyword': '沉金厚度', 'category': '线路信息', 'description': '', 'type': 'range', 'unit': [], 'expect': {'keyword': '沉金厚度', 'min': '', 'max': '', 'unit': '', 'sourceText': ''}}, {'keyword': '沉金镍厚', 'category': '线路信息', 'description': '', 'type': 'int', 'unit': [], 'expect': {'keyword': '沉金镍厚', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '沉银厚度', 'category': '线路信息', 'description': '', 'type': 'int', 'unit': [], 'expect': {'keyword': '沉银厚度', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '喷锡厚度', 'category': '线路信息', 'description': '', 'type': 'range', 'unit': [], 'expect': {'keyword': '喷锡厚度', 'min': '', 'max': '', 'unit': '', 'sourceText': ''}}, {'keyword': '钯厚', 'category': '线路信息', 'description': 'ENEPIG工艺中钯层厚度', 'type': 'int', 'unit': [], 'expect': {'keyword': '钯厚', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'OSP厚度', 'category': '线路信息', 'description': '', 'type': 'range', 'unit': [], 'expect': {'keyword': 'OSP厚度', 'min': '', 'max': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'A面沉金面积', 'category': '线路信息', 'description': 'A面沉金处理区域占总面积比例', 'type': 'int', 'unit': [], 'expect': {'keyword': 'A面沉金面积', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'B面沉金面积', 'category': '线路信息', 'description': 'B面沉金处理区域占总面积比例', 'type': 'int', 'unit': [], 'expect': {'keyword': 'B面沉金面积', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '镀金手指', 'category': '线路信息', 'description': '插接部位镀硬金', 'type': 'str', 'expect': {'keyword': '镀金手指', 'value': '', 'sourceText': ''}}, {'keyword': '镀金厚度', 'category': '线路信息', 'description': '', 'type': 'int', 'unit': [], 'expect': {'keyword': '镀金厚度', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '镀金镍厚度', 'category': '线路信息', 'description': '', 'type': 'int', 'unit': [], 'expect': {'keyword': '镀金镍厚度', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'A面镀金面积', 'category': '线路信息', 'description': 'A面电镀金区域占比', 'type': 'int', 'unit': [], 'expect': {'keyword': 'A面镀金面积', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'B面镀金面积', 'category': '线路信息', 'description': 'B面电镀金区域占比', 'type': 'int', 'unit': [], 'expect': {'keyword': 'B面镀金面积', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'A面阻焊颜色', 'category': '阻焊字符', 'description': 'A面阻焊油墨颜色', 'type': 'str', 'expect': {'keyword': 'A面阻焊颜色', 'value': '', 'sourceText': ''}}, {'keyword': 'B面阻焊颜色', 'category': '阻焊字符', 'description': 'B面阻焊油墨颜色', 'type': 'str', 'expect': {'keyword': 'B面阻焊颜色', 'value': '', 'sourceText': ''}}, {'keyword': 'A面阻焊型号', 'category': '阻焊字符', 'description': 'A面阻焊油墨材料型号', 'type': 'str', 'expect': {'keyword': 'A面阻焊型号', 'value': '', 'sourceText': ''}}, {'keyword': 'B面阻焊型号', 'category': '阻焊字符', 'description': 'B面阻焊油墨材料型号', 'type': 'str', 'expect': {'keyword': 'B面阻焊型号', 'value': '', 'sourceText': ''}}, {'keyword': '铜面阻焊厚度', 'category': '阻焊字符', 'description': '', 'type': 'int', 'unit': [], 'expect': {'keyword': '铜面阻焊厚度', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '拐角阻焊厚度', 'category': '阻焊字符', 'description': '板边/拐角处阻焊厚度', 'type': 'int', 'unit': [], 'expect': {'keyword': '拐角阻焊厚度', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '线间阻焊厚度', 'category': '阻焊字符', 'description': '线路之间的阻焊覆盖厚度', 'type': 'int', 'unit': [], 'expect': {'keyword': '线间阻焊厚度', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '塞孔阻焊厚度', 'category': '阻焊字符', 'description': '过孔塞油墨后的表面厚度', 'type': 'int', 'unit': [], 'expect': {'keyword': '塞孔阻焊厚度', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '塞孔深度', 'category': '阻焊字符', 'description': '油墨塞入过孔的深度', 'type': 'int', 'unit': [], 'expect': {'keyword': '塞孔深度', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '塞孔方式', 'category': '阻焊字符', 'description': '树脂塞孔、电镀填平、油墨塞孔', 'type': 'str', 'expect': {'keyword': '塞孔方式', 'value': '', 'sourceText': ''}}, {'keyword': '帽子电镀', 'category': '阻焊字符', 'description': '过孔孔口镀铜加厚（防爆孔）', 'type': 'str', 'expect': {'keyword': '帽子电镀', 'value': '', 'sourceText': ''}}, {'keyword': '树脂凹陷', 'category': '阻焊字符', 'description': '树脂填充后的表面凹陷深度', 'type': 'int', 'unit': [], 'expect': {'keyword': '树脂凹陷', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': 'A面字符颜色', 'category': '阻焊字符', 'description': 'A面丝印标识颜色（如白色、黄色）', 'type': 'str', 'expect': {'keyword': 'A面字符颜色', 'value': '', 'sourceText': ''}}, {'keyword': 'B面字符颜色', 'category': '阻焊字符', 'description': 'B面丝印标识颜色（如白色、黄色）', 'type': 'str', 'expect': {'keyword': 'B面字符颜色', 'value': '', 'sourceText': ''}}, {'keyword': 'A面字符型号', 'category': '阻焊字符', 'description': 'A面字符油墨型号', 'type': 'str', 'expect': {'keyword': 'A面字符型号', 'value': '', 'sourceText': ''}}, {'keyword': 'B面字符型号', 'category': '阻焊字符', 'description': 'B面字符油墨型号', 'type': 'str', 'expect': {'keyword': 'B面字符型号', 'value': '', 'sourceText': ''}}, {'keyword': '字符厚度', 'category': '阻焊字符', 'description': '', 'type': 'int', 'unit': [], 'expect': {'keyword': '字符厚度', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '白油块厚度', 'category': '阻焊字符', 'description': '局部白色阻焊块的厚度', 'type': 'int', 'unit': [], 'expect': {'keyword': '', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '白油块用途', 'category': '阻焊字符', 'description': '用于标记或反射光信号', 'type': 'str', 'expect': {'keyword': '白油块用途', 'value': '', 'sourceText': ''}}, {'keyword': '二维码要求', 'category': '阻焊字符', 'description': '二维码内容、尺寸、精度等', 'type': 'str', 'expect': {'keyword': '二维码要求', 'value': '', 'sourceText': ''}}, {'keyword': '二维码规则', 'category': '阻焊字符', 'description': '二维码编码格式（如Data Matrix）。', 'type': 'str', 'expect': {'keyword': '二维码规则', 'value': '', 'sourceText': ''}}, {'keyword': '二维码类型', 'category': '阻焊字符', 'description': '激光雕刻、油墨印刷', 'type': 'str', 'expect': {'keyword': '二维码类型', 'value': '', 'sourceText': ''}}, {'keyword': '二维码生产方式', 'category': '阻焊字符', 'description': 'LDI曝光、喷墨打印等', 'type': 'str', 'expect': {'keyword': '二维码生产方式', 'value': '', 'sourceText': ''}}, {'keyword': 'UL logo', 'category': '阻焊字符', 'description': 'UL认证标识的印刷要求', 'type': 'str', 'expect': {'keyword': 'UL logo', 'value': '', 'sourceText': ''}}, {'keyword': '周期格式', 'category': '阻焊字符', 'description': '生产周期码的格式（如YYWW）', 'type': 'str', 'expect': {'keyword': '周期格式', 'value': '', 'sourceText': ''}}, {'keyword': 'logo位置', 'category': '阻焊字符', 'description': '客户标识/UL标志的放置位置', 'type': 'str', 'expect': {'keyword': 'logo位置', 'value': '', 'sourceText': ''}}, {'keyword': '蓝胶', 'category': '阻焊字符', 'description': '用于局部绝缘的蓝色阻焊材料', 'type': 'str', 'expect': {'keyword': '蓝胶', 'value': '', 'sourceText': ''}}, {'keyword': '蓝胶塞孔', 'category': '阻焊字符', 'description': '用蓝胶填充特定过孔', 'type': 'str', 'expect': {'keyword': '蓝胶塞孔', 'value': '', 'sourceText': ''}}, {'keyword': '蓝胶面向', 'category': '阻焊字符', 'description': '蓝胶施加面（A/B面）。', 'type': 'str', 'expect': {'keyword': '蓝胶面向', 'value': '', 'sourceText': ''}}, {'keyword': '蓝胶厚度', 'category': '阻焊字符', 'description': '', 'type': 'int', 'unit': [], 'expect': {'keyword': '蓝胶厚度', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '蓝胶型号', 'category': '阻焊字符', 'description': '', 'type': 'str', 'expect': {'keyword': '蓝胶型号', 'value': '', 'sourceText': ''}}, {'keyword': '碳油', 'category': '阻焊字符', 'description': '导电碳浆印刷', 'type': 'str', 'expect': {'keyword': '碳油', 'value': '', 'sourceText': ''}}, {'keyword': '碳油面向', 'category': '阻焊字符', 'description': '碳油印刷面（A/B面）', 'type': 'str', 'expect': {'keyword': '碳油面向', 'value': '', 'sourceText': ''}}, {'keyword': '碳油厚度', 'category': '阻焊字符', 'description': '', 'type': 'int', 'unit': [], 'expect': {'keyword': '碳油厚度', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '碳油型号', 'category': '阻焊字符', 'description': '', 'type': 'str', 'expect': {'keyword': '碳油型号', 'value': '', 'sourceText': ''}}, {'keyword': '碳油阻值', 'category': '阻焊字符', 'description': '碳膜电阻值', 'type': 'int', 'unit': [], 'expect': {'keyword': '', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '碳油方阻', 'category': '阻焊字符', 'description': '单位面积电阻值', 'type': 'int', 'unit': [], 'expect': {'keyword': '碳油方阻', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '黄金胶', 'category': '阻焊字符', 'description': '含金填料的导电胶（高频应用）', 'type': 'str', 'expect': {'keyword': '黄金胶', 'value': '', 'sourceText': ''}}, {'keyword': '黄金胶面向', 'category': '阻焊字符', 'description': '', 'type': 'str', 'expect': {'keyword': '黄金胶面向', 'value': '', 'sourceText': ''}}, {'keyword': '黄金胶类型', 'category': '阻焊字符', 'description': '', 'type': 'str', 'expect': {'keyword': '黄金胶类型', 'value': '', 'sourceText': ''}}, {'keyword': '包装块数', 'category': '包装要求', 'description': '每包/箱的PCB数量。', 'type': 'int', 'unit': [], 'expect': {'keyword': '包装块数', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '干燥剂', 'category': '包装要求', 'description': '防潮包装用吸湿剂', 'type': 'str', 'expect': {'keyword': '干燥剂', 'value': '', 'sourceText': ''}}, {'keyword': '湿度卡', 'category': '包装要求', 'description': '监测包装内湿度的指示卡', 'type': 'str', 'expect': {'keyword': '湿度卡', 'value': '', 'sourceText': ''}}, {'keyword': '气泡膜', 'category': '包装要求', 'description': '防震包装材料', 'type': 'str', 'expect': {'keyword': '气泡膜', 'value': '', 'sourceText': ''}}, {'keyword': '防静电真空包装', 'category': '包装要求', 'description': 'ESD防护+真空密封', 'type': 'str', 'expect': {'keyword': '防静电真空包装', 'value': '', 'sourceText': ''}}, {'keyword': 'PE袋包装', 'category': '包装要求', 'description': '防静电聚乙烯袋', 'type': 'str', 'expect': {'keyword': 'PE袋包装', 'value': '', 'sourceText': ''}}, {'keyword': '铝箔袋包装', 'category': '包装要求', 'description': '防潮防静电铝箔袋', 'type': 'str', 'expect': {'keyword': '铝箔袋包装', 'value': '', 'sourceText': ''}}, {'keyword': '隔白纸要求', 'category': '包装要求', 'description': 'PCB间隔离用白纸（无硫）', 'type': 'str', 'expect': {'keyword': '隔白纸要求', 'value': '', 'sourceText': ''}}, {'keyword': '隔无硫纸要求', 'category': '包装要求', 'description': '防止硫腐蚀的隔离纸', 'type': 'str', 'expect': {'keyword': '隔无硫纸要求', 'value': '', 'sourceText': ''}}, {'keyword': '特殊纸箱规格', 'category': '包装要求', 'description': '定制包装箱尺寸/材质。', 'type': 'str', 'expect': {'keyword': '特殊纸箱规格', 'value': '', 'sourceText': ''}}, {'keyword': '填充物', 'category': '包装要求', 'description': '箱内防震填充材料（如泡沫）', 'type': 'str', 'expect': {'keyword': '填充物', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '垫板要求', 'category': '包装要求', 'description': '箱内底部支撑板（防变形）。', 'type': 'str', 'expect': {'keyword': '垫板要求', 'value': '', 'unit': '', 'sourceText': ''}}, {'keyword': '备品要求', 'category': '包装要求', 'description': '额外提供的备用PCB数量。', 'type': 'str', 'expect': {'keyword': '备品要求', 'value': '', 'unit': '', 'sourceText': ''}}]\n以上json中列出了相关检查项，并遵循以下要求并给出答案：\n1、每项参数的定义可以根据description进行查看，每项参数的结果请严格参考expect结构；\n2、为了节省你输出的效率，仅输出匹配到内容的参数\n3、int捕捉 数值+单位；range通常用在捕捉公差，范围等，例如+-10%，min为-10，max为10，单位为%。 str是提取短文本，enumeration是提取枚举，注意参考配置中给定的单位范围和枚举范围的\n4、spec备注可能有多项，它的expect结构是一个数组，备注value字段输出为中文；ocr会存在模糊，所以当你发现ocr与图片信息有差异时，value信息以图片为准，sourceText以ocr为准且不得更改原文内容，因为我需要根据ocr原文片段去识别文字所在坐标5、注意返回格式是对象的json类型，而非数组，同时使用对象json结构以便于使用JSON.parse的方式提取结果。将匹配到的json内容置于box中，期望格式：\n<box>\n{keyword1: keyword1_expect, keyword2: keyword2_expect，“spec备注”：expect}\n</box>",
            "position": "common",
            "not_null": true,
            "only_one": false
        },
        "阻抗数据": {
            "params": [
                "阻抗数据",
                "阻抗备注"
            ],
            "prompt": "你是一个pcb辅助制造的专家，专注于pcb的制前处理检查， 现在需要你从文件中提取出pcb阻抗数据，在分析内容后输出答案，并遵循以下要求：\n1、以下是一份提取的要求配置，请参考配置并按照对应项的expect格式输出对应json：\n[{'keyword': '阻抗数据', 'type': 'table', 'category': '阻抗数据', 'description': '‘阻抗类型’：区分是单端阻抗还是差分阻抗。‘控制层’：代表阻抗所在层。‘参考层’：分为上参考层和下参考层', 'unit': ['mm', 'um', 'mil'], 'fields': ['阻抗类型', '控制层', '上参考层', '下参考层', '线宽', '线距', '线到铜距离', '阻抗要求', '阻抗公差', 'sourceText'], 'expect': [{'阻抗类型': '', '控制层': '', '上参考层': '', '下参考层': '', '线宽': '', '线距': '', '线到铜距离': '', '阻抗要求': '', '阻抗公差': '', 'sourceText': ''}]}, {'keyword': '阻抗备注', 'category': '基础信息', 'description': '在阻抗数据的文件内提取阻抗相关的备注要求', 'type': 'text', 'expect': [{'keyword': '阻抗备注', 'value': '', 'sourceText': ''}]}]\n2、阻抗备注可能有多项，它的expect结构是一个数组，备注value字段输出为中文；ocr会存在模糊，所以当你发现ocr与图片信息有差异时，value信息以图片为准，sourceText以ocr为准且不得更改原文内容，因为我需要根据ocr原文片段去识别文字所在坐标3、将最终json答案放入box标签中，同时使用对象json结构以便于使用JSON.parse的方式提取结果，期望格式：<box>\n{\"阻抗数据\": expect, \"阻抗备注\": expect}\n</box>",
            "position": "impedance",
            "not_null": true,
            "only_one": false
        },
        "层压结构": {
            "params": [
                "压合结构",
                "层压结构备注"
            ],
            "prompt": "你是一个pcb辅助制造的专家，专注于pcb的制前处理检查， 现在需要你从文件中提取出pcb压合结构信息及备注信息，在分析内容后输出答案，并遵循以下要求：\n1、以下是一份提取的要求配置，请参考配置并按照对应项的expect格式输出对应json：\n[{'keyword': '压合结构', 'type': 'table', 'category': '压合结构', 'description': '`铜箔类型`: 仅对铜层有效，如 HTE (高温高延伸性铜箔)，RTF (反转处理铜箔),STD 等。若无则为空;`物料`: 该层的材料类型，如 PP, Core,Copper`板芯是否含铜`: 仅对Core层有效，判断该板芯两侧是否自带铜箔。`介质厚度公差`: 仅对介质层有效，其厚度公差，如 +/- 10%', 'unit': ['mm', 'um', 'mil'], 'fields': ['层名', '物料', '铜箔类型', '介质', '含铜', '残铜率(%)', '厚度', '厚度单位', '介质厚度公差', 'sourceText'], 'expect': [{'层名': '', '物料': '', '铜箔类型': '', '介质': '', '含铜': '', '残铜率(%)': '', '厚度': '', '厚度单位': '', '介质厚度公差': '', 'sourceText': ''}]}, {'keyword': '层压结构备注', 'category': '基础信息', 'description': '在层压结构的文件内提取层压结构相关的备注要求', 'type': 'text', 'expect': [{'keyword': '层压结构备注', 'value': '', 'sourceText': ''}]}]\n2、层压结构备注可能有多项，它的expect结构是一个数组，备注value字段输出为中文；ocr会存在模糊，所以当你发现ocr与图片信息有差异时，value信息以图片为准，sourceText以ocr为准且不得更改原文内容，因为我需要根据ocr原文片段去识别文字所在坐标3、将最终json答案放入box标签中，同时使用对象json结构以便于使用JSON.parse的方式提取结果，期望格式：<box>\n{\"压合结构\": expect, \"层压结构备注\": expect}\n</box>",
            "position": "structure",
            "not_null": true,
            "only_one": false
        }
    },
    "file_pre_analyse_prompt": "以下是一份含有描述的标签配置：\n[{'label': '客户订单', 'description': '客户向PCB制造商下发的正式采购订单，一般包含订单编号，产品型号，数量，交货日期，价格条款等'}, {'label': 'ENG文件', 'description': 'PCB工程制造文件，包含工艺参数、特殊加工要求（如阻抗控制、沉金厚度）、层压结构及关键生产指示。'}, {'label': 'ECN文件', 'description': '工程变更通知文件，记录设计或工艺的变更内容（如材料替换、线路调整、孔位修改），确保生产与最新要求一致。'}, {'label': 'SOW文件', 'description': '项目工作说明书，明确PCB项目的范围、交付物、验收标准、里程碑节点及双方责任划分。'}, {'label': '层压结构', 'description': 'PCB叠层设计规范，定义各层材料（如FR-4、高频材料）、厚度、铜箔重量（如1oz）、介电常数及层间对准要求。'}, {'label': '阻抗数据', 'description': 'PCB关键信号线的阻抗控制要求，包括目标阻抗值（如50Ω）、线宽/线距、参考层及容许偏差范围。'}, {'label': 'SPEC文件', 'description': 'PCB技术规格文档，涵盖产品性能标准、材料规格、工艺要求（如IPC标准）、测试方法及验收准则。'}]以下是一份含有语言配置：\n['English', 'Chinese', 'Japanese', 'Italian', 'Korean', 'Other']你是一个pcb辅助制造的专家， 现在请帮助我识别当前文件含有上述标签中的哪几项，以及哪几项语言语言并遵循以下规则: 1、文件内容一般都是聚集出现的，需要出现足够的信息标志才可认定具有某个标签2、3、进行分析后，在末尾要求答案填入box中，预期：<box>\n{\"labels\": [], \"language\":[]}\n</box>"
}

const a = 0